// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"88a95a74","138":"3f977715","177":"8f043a20","375":"846081eb","591":"57be76c8","707":"58297cc3","825":"03c3b01a","828":"679dad47"}[chunkId] + ".chunk.js";
};